import React from 'react';
import styled from 'styled-components';

import LoadingDots from './LoadingDots';

const LoadingDotsWrapper = styled.div`
    display: block;
    height: 60px;
    width: 100%;
    min-width: 60px;
    margin: 0 auto;
    padding: 22px 0 0 0;
`;

export const PageSpinner = domProps => (
    <LoadingDotsWrapper {...domProps}>
        <LoadingDots alt='Loading' />
    </LoadingDotsWrapper>
);

export default PageSpinner;
